/**
 * Recipe Blog Grid JavaScript
 * Handles tag filtering and dynamic content display
 */

class RecipeBlogGrid {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('.recipe-blog-grid__grid');
    this.cards = section.querySelectorAll('.recipe-blog-grid__card');
    this.filterButtons = section.querySelectorAll('.recipe-blog-grid__filter-btn');
    this.noResults = section.querySelector('.recipe-blog-grid__no-results');
    this.resetBtn = section.querySelector('.recipe-blog-grid__reset-btn');
    
    this.activeFilter = 'all';
    this.init();
  }

  init() {
    // Initialize filter buttons
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleFilterClick(e));
    });

    // Initialize reset button
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => this.resetFilters());
    }

    // Check URL parameters for initial filter
    this.checkUrlParams();
  }

  handleFilterClick(e) {
    const button = e.currentTarget;
    const filter = button.dataset.filter;
    
    // Update active states
    this.filterButtons.forEach(btn => {
      btn.classList.remove('recipe-blog-grid__filter-btn--active');
      btn.setAttribute('aria-pressed', 'false');
    });
    
    button.classList.add('recipe-blog-grid__filter-btn--active');
    button.setAttribute('aria-pressed', 'true');
    
    // Apply filter
    this.activeFilter = filter;
    this.filterRecipes(filter);
    
    // Update URL
    this.updateUrl(filter);
  }

  filterRecipes(filter) {
    let visibleCount = 0;
    
    this.cards.forEach((card, index) => {
      const tags = card.dataset.tags ? card.dataset.tags.toLowerCase() : '';
      const shouldShow = filter === 'all' || tags.includes(filter);
      
      if (shouldShow) {
        card.style.display = '';
        card.classList.remove('recipe-blog-grid__card--hidden');
        // Add staggered animation
        card.style.animationDelay = `${visibleCount * 0.1}s`;
        visibleCount++;
      } else {
        card.style.display = 'none';
        card.classList.add('recipe-blog-grid__card--hidden');
      }
    });
    
    // Show/hide no results message
    if (visibleCount === 0) {
      this.grid.style.display = 'none';
      this.noResults.style.display = 'block';
    } else {
      this.grid.style.display = '';
      this.noResults.style.display = 'none';
    }
  }

  resetFilters() {
    // Find and click the "All" button
    const allButton = Array.from(this.filterButtons).find(btn => btn.dataset.filter === 'all');
    if (allButton) {
      allButton.click();
    }
  }

  updateUrl(filter) {
    const url = new URL(window.location);
    
    if (filter === 'all') {
      url.searchParams.delete('tag');
    } else {
      url.searchParams.set('tag', filter);
    }
    
    // Update URL without page reload
    window.history.pushState({}, '', url);
  }

  checkUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const tagParam = urlParams.get('tag');
    
    if (tagParam) {
      const button = Array.from(this.filterButtons).find(btn => btn.dataset.filter === tagParam);
      if (button) {
        button.click();
      }
    }
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.recipe-blog-grid');
  sections.forEach(section => {
    new RecipeBlogGrid(section);
  });
});

// Reinitialize on Shopify section reload (theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.recipe-blog-grid');
  if (section) {
    new RecipeBlogGrid(section);
  }
});